export const Campaign = {
  create: {
    url: '/campaign/create',
    method: ['POST'],
  },
  update: {
    url: '/campaign',
    method: ['PUT'],
  },
  getStatus: {
    url: '/campaign/status',
    method: ['GET'],
  },
  get: {
    url: 'campaign',
    method: ['GET'],
  },
  getById: {
    url: '/campaign/detail/{campaignId}',
    method: ['GET'],
  },
  getByIdWithoutDetail: {
    url: '/campaign/{campaignId}',
    method: ['GET'],
  },
  updateMemberCampaignStatus: {
    url: '/campaign/member/status',
    method: ['PUT'],
  },

  getStatusMember: {
    url: '/campaign/member/status',
    method: ['GET'],
  },

  uploadFile: {
    url: 'campaign/upload/file',
    method: ['POST'],
  },
  deleteFile: {
    url: 'campaign/delete/file',
    method: ['POST'],
  },
  getIssues: {
    url: '/campaign/issues',
    method: ['GET'],
  },
  getCampaignsProducts: {
    url: '/campaign/products/{campaignId}',
    method: ['GET'],
  },
  delete: {
    url: '/campaign/delete/{campaignId}',
    method: ['POST'],
  },
  getAllProducts: {
    url: '/campaign/products',
    method: ['GET'],
  },
  personStatus: {
    url: '/campaign/personStatus',
    method: ['POST'],
  },
  uploadChallengeFile: {
    url: 'campaign/upload/file/challenge',
    method: ['POST'],
  },
};
